class MenuController {
    constructor($state) {
        this.$state = $state;
    }

    $onInit() {
        this.elements = this.elements || [];
    }

    go(item) {
        this.onChange({$event: {route: item}});
        this.$state.go(item.url, {lang: this.language});
    }
}

export default MenuController;


//////////////////
// WEBPACK FOOTER
// ./src/menu/menu.controller.js
// module id = 640
// module chunks = 0